import { BuffType } from '@/game/types';

export function buffCdStorageKey(heroId: number): string {
  return `autohero-buffCd-v1-${heroId}`;
}

export function pruneCooldownEnds(
  raw: Partial<Record<BuffType, number>>,
  now: number,
): Partial<Record<BuffType, number>> {
  const out: Partial<Record<BuffType, number>> = {};
  for (const [k, v] of Object.entries(raw)) {
    if (typeof v === 'number' && v > now && (Object.values(BuffType) as string[]).includes(k)) {
      out[k as BuffType] = v;
    }
  }
  return out;
}

export function loadCooldownsFromStorage(heroId: number): Partial<Record<BuffType, number>> {
  try {
    const raw = sessionStorage.getItem(buffCdStorageKey(heroId));
    if (!raw) return {};
    const parsed = JSON.parse(raw) as Partial<Record<BuffType, number>>;
    return pruneCooldownEnds(parsed, Date.now());
  } catch {
    return {};
  }
}

export function saveCooldownsToStorage(heroId: number, ends: Partial<Record<BuffType, number>>): void {
  try {
    const pruned = pruneCooldownEnds(ends, Date.now());
    sessionStorage.setItem(buffCdStorageKey(heroId), JSON.stringify(pruned));
  } catch {
    /* ignore quota / private mode */
  }
}
